import { useEffect, useState } from 'react';
import request from '../../utils/request';
import {
  Alert,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputAdornment,
  TextField
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CreateEdit from './createEditInitiateClaim';
import PolicyClaimSurveyorEdit from './policyClaimSurveyorEdit';

function AssignSurveyorOtpView() {
  const [otpFromTextbox, setOtpFromTextbox] = useState<string | null>(null);
  const [sendLoader, setSendLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState<string | null>(null);
  const [showTimeRemaining, setShowTimeRemaining] = useState(false);
  const [seconds, setSeconds] = useState<number | null>(null);
  const [decodedArray, setDecodedArray] = useState<any>(null);
  const [claimsView, setClaimsView] = useState(false);
  const [claimSharedToCompany, setClaimSharedToCompany] = useState(false);
  const [claimSharedToInsured, setClaimSharedToInsured] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [thirdParty, setThirdParty] = useState(false);
  const [branchContactEmail, setBranchContactEmail] = useState<string | null>(
    null
  );

  useEffect(() => {
    fetchClaimIdFromUrl();
  }, []);

  console.log(decodedArray);

  useEffect(() => {
    if (decodedArray) {
      fetchBranchContactEmail();
    }
  }, [decodedArray]);

  const fetchClaimIdFromUrl = () => {
    try {
      const pathParts = window.location.href.split('/');
      const encodedString = pathParts[pathParts.length - 1];
      const decoded = atob(encodedString);
      const parsed = JSON.parse(decoded);

      setDecodedArray(parsed);
    } catch (err) {
      console.error('URL decoding error:', err);
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Invalid verification link'
      });
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showTimeRemaining && seconds !== null && seconds > 0) {
      timer = setTimeout(() => setSeconds(seconds - 1), 1000);
    } else if (seconds === 0) {
      setOtpFromTextbox(null);
      setShowTimeRemaining(false);
    }
    return () => clearTimeout(timer);
  }, [showTimeRemaining, seconds]);

  const secondsToMinutes = (totalSeconds: number) => {
    const m = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, '0');
    const s = Math.floor(totalSeconds % 60)
      .toString()
      .padStart(2, '0');
    return `Your OTP will expire in: ${m}:${s}`;
  };

  const sendOtpToCustomer = () => {
    setSendLoader(true);
    setOtpSentMessage(null);
    request({
      url: '/otp/generateOtpForInsuranceCompanyClaims',
      method: 'post',
      data: {
        userType: 'InsuranceCompanyContact',
        userId: decodedArray.branchContactId,
        email: branchContactEmail
      }
    })
      .then((data) => {
        console.log('OTP API Response:', data);
        setSendLoader(false);
        setSeconds(120);
        setShowTimeRemaining(true);
        setOtpSentMessage(data['message'] || 'OTP sent successfully');
      })
      .catch((err) => {
        setSendLoader(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message || 'Failed to send OTP'
        });
      });
  };

  const verifyOtp = () => {
    if (!otpFromTextbox?.trim()) {
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Please enter the OTP'
      });
      return;
    }

    setSubmitLoader(true);

    request({
      url: 'otp/verifyOtp',
      method: 'post',
      data: {
        userType: 'InsuranceCompanyContact',
        userId: decodedArray.branchContactId,
        otp: otpFromTextbox
      }
    })
      .then((data) => {
        setSubmitLoader(false);
        if (data.status) {
          setClaimsView(true);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: data['message']
          });
        } else {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: data['message']
          });
          if (data['message'] === 'OTP Expired') {
            setOtpFromTextbox(null);
            setSeconds(0);
          }
        }
        setClaimSharedToCompany(true);
        setClaimSharedToInsured(false);
      })
      .catch((err) => {
        setSubmitLoader(false);
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message || 'OTP verification failed'
        });
        if (err.message === 'OTP Expired') {
          setOtpFromTextbox(null);
          setSeconds(0);
        }
      });
  };

  const fetchBranchContactEmail = () => {
    request({
      url: 'icb-contacts/getContactById',
      method: 'post',
      data: {
        id: decodedArray?.branchContactId
      }
    }).then(
      (response) => {
        setBranchContactEmail(response['email']);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  return (
    <div>
      {claimsView ? (
        <PolicyClaimSurveyorEdit
          policyClaimId={decodedArray.policyClaimId}
          claimsView={claimsView}
        />
      ) : (
        <Dialog open={true}>
          <DialogTitle>OTP Verification</DialogTitle>
          <DialogContent>
            <Container maxWidth="sm">
              <FormControl fullWidth variant="outlined">
                <TextField
                  type="text"
                  placeholder="Enter your OTP"
                  value={otpFromTextbox || ''}
                  onChange={(e) => setOtpFromTextbox(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') verifyOtp();
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <LoadingButton
                          loading={submitLoader || sendLoader}
                          variant="contained"
                          onClick={() =>
                            seconds === 0 || seconds === null
                              ? sendOtpToCustomer()
                              : verifyOtp()
                          }
                          disabled={
                            !branchContactEmail ||
                            branchContactEmail.trim() === '' ||
                            (seconds > 0 && !otpFromTextbox?.length) ||
                            sendLoader
                          }
                        >
                          {seconds === null || seconds === 0
                            ? 'Send OTP'
                            : 'Verify OTP'}
                        </LoadingButton>
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>

              <Grid container spacing={2} mt={1}>
                {showTimeRemaining && seconds !== null && (
                  <Grid item xs={12}>
                    <span>{secondsToMinutes(seconds)}</span>
                  </Grid>
                )}

                {otpSentMessage && (
                  <Grid item xs={12}>
                    <Alert severity="success">{otpSentMessage}</Alert>
                  </Grid>
                )}

                {showSnackBarAlert.status && showSnackBarAlert.message && (
                  <Grid item xs={12}>
                    {/* <Alert severity={showSnackBarAlert.type}>
                      {showSnackBarAlert.message}
                    </Alert> */}
                  </Grid>
                )}
              </Grid>
            </Container>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}

export default AssignSurveyorOtpView;
